import React from 'react'
import { Modal, Button } from '@driftt/tide-core-legacy'
import advancedRoutingOptInSrc from 'images/advancedRoutingOptIn.jpg'

import './style.styl'

const AdvancedRoutingOptInModal = ({ onClose, optIntoAdvancedRouting }) => (
  <Modal
    onClose={onClose}
    open={true}
    size="medium"
    className="advanced-routing-opt-in-modal"
    title="What's new in routing"
  >
    <div className="advanced-routing-opt-in-modal-content">
      <div className="advanced-routing-opt-in-modal-image-container">
        <img className="advanced-routing-opt-in-image" src={advancedRoutingOptInSrc} />
      </div>
      <div className="advanced-routing-opt-in-info-container">
        <h2>Introducing Advanced Routing</h2>
        Easily build out your routing rules with our new drag-and-drop visual builder, so you can connect the right site visitors with the right teammates in real-time!
        <div className="advanced-routing-opt-in-modal-footer">
          <Button type="primary" onClick={optIntoAdvancedRouting}>Try it now!</Button>
          <Button type="tertiary" onClick={onClose}>I'll try it later</Button>
        </div>
      </div>
    </div>
  </Modal>
)

export default AdvancedRoutingOptInModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/layouts/AdvancedRoutingOptInModal/index.js